import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "Wedding Catering",
        details: {
            eventType: "Wedding Catering",
            capacity: "Accommodates up to 150 guests",
            cuisine: "Gourmet, Customizable Menus",
            location: "Various venues available",
            priceRange: "$5,000 - $7,000",
            includes: "Full-service catering, premium bar, decor options",
            duration: "6:00 PM - 11:00 PM",
            booking: "Minimum 2 months in advance",
            specialFeatures: "Personalized event planning, exclusive menu options",
            email: "events@bistro.com",
            phoneNumber: "(555) 123-4567"
        },
        overviews: [
            "Welcome to our Wedding Catering service! We specialize in creating unforgettable culinary experiences tailored to your unique wedding vision, ensuring every detail is perfect for your special day."
        ],
        highlights: [
            "Custom Menu Design",
            "Expert Event Planning",
            "Elegant Table Settings",
            "Professional Service Staff",
            "Beautiful Presentation"
        ],
        benefits: [
            "Personalized Culinary Experience",
            "Stress-Free Planning Process",
            "Seamless Coordination on Your Big Day",
            "Memorable Dining Experience for Guests",
            "Attention to Detail and Quality"
        ],
        customizations: [
            "Tailored Menus to Suit Your Preferences",
            "Dietary Accommodations for Guests",
            "Themed Presentations and Decor",
            "Flexible Service Styles (Buffet, Plated, Family-Style)",
            "Coordination with Wedding Planners"
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2,
            images.event1Gallery3,
            images.event1Gallery4,
            images.event1Gallery5,
            images.event1Gallery6,
            images.event1Gallery7,
            images.event1Gallery8,
            images.event1Gallery9,
        ],
        services: [1, 2, 3, 4],
        menuCategories: ["platedDinnerCategory", "gourmetCanapésCategory", "signatureCocktailsCategory"],
        venues: [1, 2, 6],
    },
    {
        id: 2,
        image: images.event2,
        title: "Corporate Parties",
        details: {
            eventType: "Corporate Parties",
            capacity: "Accommodates up to 200 guests",
            cuisine: "International, Customizable Menus",
            location: "On-site or selected corporate venues",
            priceRange: "$4,000 - $6,500",
            includes: "Full-service catering, beverage packages, AV setup",
            duration: "5:00 PM - 10:00 PM",
            booking: "Minimum 1 month in advance",
            specialFeatures: "Brand-themed decor, customizable service flow",
            email: "events@bistro.com",
            phoneNumber: "(555) 123-4567"
        },
        overviews: [
            "Our Corporate Party Catering service is designed to elevate your professional gatherings with exceptional cuisine, seamless service, and a refined atmosphere that aligns with your company’s brand and culture."
        ],
        highlights: [
            "Custom Business Menus",
            "Experienced Event Coordination",
            "Branded Decor Options",
            "Professional Waitstaff",
            "Smooth AV Integration"
        ],
        benefits: [
            "Professional Presentation",
            "Tailored to Your Business Needs",
            "Hassle-Free Planning and Execution",
            "Enhanced Guest Experience",
            "Supports Networking and Team Building"
        ],
        customizations: [
            "Menu Personalization Based on Company Culture",
            "Themed Decor Matching Corporate Branding",
            "Flexible Service Styles (Buffet, Cocktail, Seated)",
            "Presentation Materials and AV Support",
            "Coordination with Event Managers"
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2,
            images.event2Gallery3,
            images.event2Gallery4,
            images.event2Gallery5,
            images.event2Gallery6,
            images.event2Gallery7,
            images.event2Gallery8,
            images.event2Gallery9,
        ],
        services: [5, 2, 1],
        menuCategories: ["buffetFeastCategory", "gourmetCanapésCategory", "signatureCocktailsCategory"],
        venues: [4, 1, 3],
    },
    {
        id: 3,
        image: images.event3,
        title: "Private Parties",
        details: {
            eventType: "Private Parties",
            capacity: "Accommodates up to 100 guests",
            cuisine: "Fusion, Customized Menus",
            location: "At home or selected private venues",
            priceRange: "$3,000 - $5,500",
            includes: "Full-service catering, themed decor, entertainment options",
            duration: "6:00 PM - 12:00 AM",
            booking: "Minimum 3 weeks in advance",
            specialFeatures: "Intimate setups, entertainment coordination",
            email: "events@bistro.com",
            phoneNumber: "(555) 123-4567"
        },
        overviews: [
            "Make your celebration unforgettable with our Private Party Catering service, offering delicious food, stylish presentation, and a personalized touch that brings your vision to life."
        ],
        highlights: [
            "Themed Menu Options",
            "Custom Decor Styling",
            "Attentive Service Staff",
            "Flexible Venue Choices",
            "Entertainment Arrangements"
        ],
        benefits: [
            "Personalized Event Experience",
            "Flexible Planning and Coordination",
            "Stress-Free Hosting",
            "Impressive Culinary Selection",
            "Perfect for Birthdays, Anniversaries & More"
        ],
        customizations: [
            "Bespoke Menus for Your Occasion",
            "Decor Aligned with Your Theme",
            "Live Cooking Stations or Cocktail Bars",
            "Entertainment and DJ Services",
            "Flexible Layouts and Seating Plans"
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2,
            images.event3Gallery3,
            images.event3Gallery4,
            images.event3Gallery5,
            images.event3Gallery6,
            images.event3Gallery7,
            images.event3Gallery8,
            images.event3Gallery9,
        ],
        services: [3, 4, 1],
        menuCategories: ["bbqStationCategory", "buffetFeastCategory", "signatureCocktailsCategory"],
        venues: [3, 2, 5],
    },
    {
        id: 4,
        image: images.event4,
        title: "Holiday Celebrations",
        details: {
            eventType: "Holiday Celebrations",
            capacity: "Accommodates up to 180 guests",
            cuisine: "Seasonal, Festive Menus",
            location: "Indoor/outdoor festive venues",
            priceRange: "$4,500 - $6,800",
            includes: "Full-service catering, festive decor, entertainment",
            duration: "4:00 PM - 11:00 PM",
            booking: "Minimum 1 month in advance",
            specialFeatures: "Holiday-themed setups, seasonal treats & drinks",
            email: "events@bistro.com",
            phoneNumber: "(555) 123-4567"
        },
        overviews: [
            "Celebrate the magic of the season with our Holiday Catering service, bringing joy, flavor, and festive charm to your Christmas parties, New Year's Eve events, and more."
        ],
        highlights: [
            "Festive Menus with Seasonal Flavors",
            "Holiday-Themed Decor & Setup",
            "Professional Service Team",
            "Entertainment & Music Options",
            "Warm and Cozy Ambience"
        ],
        benefits: [
            "Celebrate Without the Stress",
            "All-Inclusive Planning & Service",
            "Impress Guests with Elegant Flavors",
            "Flexible Setup for Indoor & Outdoor Venues",
            "Perfect for Families, Companies & Communities"
        ],
        customizations: [
            "Custom Holiday Menus (Traditional or Modern)",
            "Themed Decor for Different Holidays",
            "Live Music, Santa Visits, or DJ Services",
            "Hot Beverage Stations and Dessert Bars",
            "Flexible Dining Styles (Buffet, Seated, Casual)"
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2,
            images.event4Gallery3,
            images.event4Gallery4,
            images.event4Gallery5,
            images.event4Gallery6,
            images.event4Gallery7,
            images.event4Gallery8,
            images.event4Gallery9,
        ],
        services: [2, 1, 5],
        menuCategories: ["buffetFeastCategory", "platedDinnerCategory", "signatureCocktailsCategory"],
        venues: [4, 1, 2],
    },
    {
        id: 5,
        image: images.event5,
        title: "Special Occasions",
        details: {
            eventType: "Special Occasions",
            capacity: "Accommodates up to 120 guests",
            cuisine: "Tailored, Multi-Course Menus",
            location: "Choice of elegant indoor/outdoor venues",
            priceRange: "$3,800 - $6,000",
            includes: "Full catering service, decor customization, personalized setup",
            duration: "5:00 PM - 10:00 PM",
            booking: "Minimum 1 month in advance",
            specialFeatures: "Customized experiences, premium presentation",
            email: "events@bistro.com",
            phoneNumber: "(555) 123-4567"
        },
        overviews: [
            "Whether it's a milestone birthday, anniversary, engagement, or any personal celebration, our Special Occasions service ensures a memorable experience filled with elegant cuisine and thoughtful details."
        ],
        highlights: [
            "Elegant Menu Designs",
            "Sophisticated Decor Options",
            "Professional and Friendly Staff",
            "Custom Entertainment Options",
            "Intimate and Personal Touch"
        ],
        benefits: [
            "Unique and Memorable Celebrations",
            "Completely Customizable Packages",
            "Expert Planning Support",
            "Premium Ingredients and Service",
            "Tailored for Your Personal Style"
        ],
        customizations: [
            "Custom Menus with Signature Dishes",
            "Themed Event Styling and Decor",
            "Personalized Welcome Displays or Favors",
            "Flexible Layout and Seating Plans",
            "Coordination with Hosts for Smooth Execution"
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2,
            images.event5Gallery3,
            images.event5Gallery4,
            images.event5Gallery5,
            images.event5Gallery6,
            images.event5Gallery7,
            images.event5Gallery8,
            images.event5Gallery9,
        ],
        services: [6, 3, 4],
        menuCategories: ["platedDinnerCategory", "gourmetCanapésCategory", "signatureCocktailsCategory"],
        venues: [6, 3, 2],
    },
    {
        id: 6,
        image: images.event6,
        title: "Outdoor Catering",
        details: {
            eventType: "Outdoor Catering",
            capacity: "Accommodates up to 200 guests",
            cuisine: "Grilled, Picnic-Style, Customizable Menus",
            location: "Gardens, Parks, Private Lawns",
            priceRange: "$4,000 - $7,200",
            includes: "Full catering setup, outdoor furniture, live stations",
            duration: "12:00 PM - 8:00 PM",
            booking: "Minimum 3 weeks in advance",
            specialFeatures: "Live BBQ stations, tented setups, nature-inspired themes",
            email: "events@bistro.com",
            phoneNumber: "(555) 123-4567"
        },
        overviews: [
            "Enjoy the beauty of nature with our Outdoor Catering service, perfect for relaxed gatherings, corporate picnics, family reunions, or garden celebrations with delicious food and scenic setups."
        ],
        highlights: [
            "Scenic Outdoor Venues",
            "Live Cooking Stations",
            "Comfortable Outdoor Seating",
            "Eco-Friendly Serving Options",
            "Versatile Menu Themes"
        ],
        benefits: [
            "Fresh Air and Relaxed Vibes",
            "Interactive Dining Experience",
            "Spacious and Safe Environment",
            "Custom Decor with Natural Elements",
            "Ideal for Daytime Celebrations"
        ],
        customizations: [
            "BBQ, Picnic, or Brunch Menus",
            "Tents, Umbrellas, and Lawn Furniture",
            "Live Grill or Beverage Stations",
            "Eco-Friendly Tableware",
            "Games and Entertainment Options"
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2,
            images.event6Gallery3,
            images.event6Gallery4,
            images.event6Gallery5,
            images.event6Gallery6,
            images.event6Gallery7,
            images.event6Gallery8,
            images.event6Gallery9,
        ],
        services: [1, 2, 4],
        menuCategories: ["bbqStationCategory", "buffetFeastCategory", "gourmetCanapésCategory"],
        venues: [2, 5, 4],
    }

];

export default events;